/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Warehouse_Sales_Kpi_Defects_NotesInputs */

const vi_warehouse_sales_kpi_defects_notes = /** @type {(inputs: Warehouse_Sales_Kpi_Defects_NotesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Số phiếu lỗi: ${i?.count}`)
};

/**

* @param {Warehouse_Sales_Kpi_Defects_NotesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_sales_kpi_defects_notes = /** @type {((inputs: Warehouse_Sales_Kpi_Defects_NotesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Sales_Kpi_Defects_NotesInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_sales_kpi_defects_notes(inputs)
});